import { ComponentType } from "react";

import ExportToXlsxButtonJs from "../../../CommonComponents/ExportToXlsxButton/ExportToXlsxButton";
import type { ExportRow } from "../../../../queries/payments/usePaymentReporting";

import styles from "./SectionHeader.module.css";

const ExportToXlsxButton = ExportToXlsxButtonJs as ComponentType<{
  filename?: string;
  data?: object[];
  loadData?: () => Promise<object[]>;
}>;

interface SectionHeaderProps {
  title: string;
  exportFilename: string;
  exportRows?: ExportRow[];
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  exportFilename,
  exportRows = [],
}) => {
  return (
    <div className={styles.sectionHeader}>
      <h2 className={styles.sectionTitle}>{title}</h2>
      <ExportToXlsxButton data={exportRows} filename={exportFilename} />
    </div>
  );
};

export default SectionHeader;
